var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2088_17680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2978 4.64099L11.3585 5.70165L9.0604 7.99974L11.3585 10.2978L10.2978 11.3585L7.99974 9.0604L5.70165 11.3585L4.64099 10.2978L6.93908 7.99974L4.64099 5.70165L5.70165 4.64099L7.99974 6.93908L10.2978 4.64099Z",
    fill: "#197A56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34317 2.34317C5.46737 -0.781019 10.5326 -0.781064 13.6568 2.34308C16.7809 5.46722 16.7809 10.5325 13.6567 13.6567C10.5325 16.7809 5.46722 16.7809 2.34308 13.6568C-0.781064 10.5326 -0.781019 5.46737 2.34317 2.34317ZM3.40383 3.40383C5.94226 0.86541 10.0578 0.8654 12.5961 3.40374C15.1345 5.94207 15.1345 10.0576 12.596 12.596C10.0576 15.1345 5.94207 15.1345 3.40374 12.5961C0.8654 10.0578 0.865409 5.94226 3.40383 3.40383Z",
    fill: "#197A56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2088_17680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.ea233072db9e67f0812362a4d7291d94.svg";
export { ForwardRef as ReactComponent };